import styled from 'styled-components'

export const StyledUl = styled.ul`
  list-style-type: none;
  display: flex;
  margin: 0;
  padding: 0;
`

export const StyledLi = styled.li`
  margin: 0;
  padding: 0;

  a {
    padding: 1rem 0.25rem;
  }
`
